import { LoadingScreen } from '@leverege/molten/screens'
import { Blocker } from '@leverege/molten/views'
import P from '@leverege/promise'
import { Content, DateTimeRangePicker, Flex } from '@leverege/ui-elements'
import React from 'react'

import { getBusinessDays } from '../../../util'
import { getStationOccupancyItems } from '../../../util/Stations'
import StationSelector from '../views/StationSelector'
import './Analytics.css'
import AnalyticsContext from './AnalyticsContext'
import HourlyAnalytics from './views/HourlyAnalytics'
import Overview from './views/Overview'
import PerDayStats from './views/PerDayStats'

export default class Analytics extends React.Component {
  constructor() {
    super()
    this.initialLoad = P.deferred()
    this.state = {
      isLoading : false,
    }
  }

  componentDidUpdate() {
    const { result } = this.props

    if ( result.items != null ) {
      this.initialLoad.resolve()
    }
  }
  
  getStationOccupancyItems = getStationOccupancyItems

  renderChildren = () => {
    const {
      result : historyResult,
      data : listResult,
      loadingPages,
      parentItem,
      queryType = 'history',
      delegate,
      filter,
      filterName,
      onFilterChange,
    } = this.props

    let range = historyResult?.start ?
      {
        start : new Date( historyResult.start ),
        end : new Date( historyResult.end ) || new Date(),
      } :
      'last7Days'
    range = DateTimeRangePicker.getRange( range )
    const { isLoading } = this.state

    const operatingHours =
      parentItem?.data?.metadata?.operatingHours?.default
    const timezone = operatingHours?.timezone || 'America/Phoenix'
    const data = this.getStationOccupancyItems( historyResult.items, listResult.items )
    const businessDays = getBusinessDays( range, operatingHours )

    return (
      <Content className="analyticsContainer">
        <Content.Header variant="analyticsHeader" style={{ display : 'none' }}/>
        <Content.Area variant="analyticsContent">
          {isLoading ? (
            <LoadingScreen />
          ) : (
            <AnalyticsContext store={parentItem}>
              <Flex variant="colL">
                <Flex variant="rowStart">
                  <StationSelector
                    // ignored={ignoredStations}
                    filter={filter}
                    delegate={delegate}
                    eventData={filterName}
                    onChange={onFilterChange}/>
                </Flex>
                <Overview
                  loading={loadingPages}
                  data={data}
                  businessDays={businessDays}
                  range={range}/>
                <PerDayStats
                  loading={loadingPages}
                  data={data}
                  businessDays={businessDays}
                  range={range}/>
                <HourlyAnalytics
                  loading={loadingPages}
                  data={data}
                  businessDays={businessDays}
                  range={range}/>
              </Flex>
            </AnalyticsContext>
          )}
        </Content.Area>
      </Content>
    )
  }

  render() {
    const { relationship } = this.props
    const { path, objectType } = relationship

    const matchContext = {
      client : Analytics.CLIENT,
      objectType,
      path,
    }

    return (
      <Blocker
        hooks={[
          {
            sort : 1000,
            execute : () => {
              return this.initialLoad
            },
          },
        ]}
        matchContext={matchContext}
        context={{ ...this.props }}
        render={this.renderChildren}/>
    )
  }
}

Analytics.CLIENT = 'AnalyticsScreen'
